import { render, staticRenderFns } from "./DetailsView.vue?vue&type=template&id=776b3c0a"
import script from "./DetailsView.vue?vue&type=script&lang=js"
export * from "./DetailsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports